import { SET_PROZESSE } from "./mutations.type";

import { LADE_AUSWAHLWERTE_PROZESS } from "./actions.type";

import AppApi from "@/api/AppApi";

export default {
  namespaced: true,
  state: {
    prozesse: [],
  },
  mutations: {
    [SET_PROZESSE](state, val) {
      state.prozesse = val;
    },
  },
  actions: {
    async [LADE_AUSWAHLWERTE_PROZESS](context) {
      let response = await AppApi.get("prozess/auswahlwerte/");
      context.commit(SET_PROZESSE, response.data.prozesse);
    },
  },
};
